import {
    SALES_BY_CATEGORY_REPORT_GET_START,
    SALES_BY_CATEGORY_REPORT_GET_SUCCESS,
    SALES_BY_CATEGORY_REPORT_GET_ERROR,
    SalesByCategoryReportAction
} from 'actions/insights/sales/SalesByCategoryReport/SalesByCategoryReportActionsType';

import {
    SalesByCategoryReportState,
    initialSalesByCategoryReportState,
    emptySalesByCategoryReport
} from './SalesByCategoryReportState';

export const salesByCategoryReportReducer = (
    state: SalesByCategoryReportState = initialSalesByCategoryReportState,
    action: SalesByCategoryReportAction
): SalesByCategoryReportState => {
    switch (action.type) {
        case SALES_BY_CATEGORY_REPORT_GET_START:
            return {
                ...state,
                loading: true
            };

        case SALES_BY_CATEGORY_REPORT_GET_SUCCESS:
            return {
                loading: false,
                report: action.payload.report
            };

        case SALES_BY_CATEGORY_REPORT_GET_ERROR:
            return {
                loading: false,
                report: emptySalesByCategoryReport
            };

        default:
            return state;
    }
};
